import { render, staticRenderFns } from "./loginWithOpenID.vue?vue&type=template&id=cf51a066"
import script from "./loginWithOpenID.vue?vue&type=script&lang=js"
export * from "./loginWithOpenID.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports